import axios from 'axios';
import applyInterceptors from '../interceptors';
import CLPLContentClient from './CLPLContentClient';
import { RequestError } from '../common/errors';

const axiosInstance = axios.create();
applyInterceptors(axiosInstance);

const clplContentClient = new CLPLContentClient(axiosInstance);

const assessment = 'CLPL';
/**
 * @param {String} token - keycloak token for API authorization
 * @returns {Promise<Object>} CLPL cutscores
 */
export const getCLPLCutscores = async token => {
    let cutscores;
    try {
        cutscores = await clplContentClient.getCutscores([], token);
    } catch (error) {
        throw new RequestError(`${assessment} get cutscores request failed`, error, assessment);
    }

    return cutscores || [];
};

/**
 * @param {String} token - keycloak token for API authorization
 * @returns {Promise<Object>} CLPL forms
 */
export const getCLPLForms = async token => {
    let forms;
    try {
        forms = await clplContentClient.getForms([], token);
    } catch (error) {
        throw new RequestError(`${assessment} get forms request failed`, error, assessment);
    }

    return forms || [];
};

export { CLPLContentClient };
